// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const ExpensesReportsLoader = Loadable({
  loader: () => import('./ExpensesReportsContainer'),
  loading: Loader,
})

export default ExpensesReportsLoader
